import { ContractsCard } from "@/components/contracts/contracts-card"
import { Contract } from "@/types/contract"
import { Button } from "../ui/button"
import { Facility } from "@/types/warehouse"
import { useTranslation } from "react-i18next"
import { EyeIcon, EyeOffIcon, LockIcon, MapPinIcon } from "@/components/icons"
import { Guard } from "@/types/guard"
import { useId, useState } from "react"
import { cn } from "@/lib/utils"

export function ContractsGroup({ facility, contracts, pinCode }: { facility: Facility, contracts: Contract[], pinCode?: Guard }) {
  const isGroupLocked = contracts.some(contract => contract.status === 'locked')
  const { t } = useTranslation()
  const [isPinCodeVisible, setIsPinCodeVisible] = useState(false)
  const nameId = useId()

  const facilityName = facility?.properties?.find(property => property.code === 'display_name')?.value ?? facility?.name ?? "";
  const facilityLocationLink = facility?.properties?.find(property => property.code === 'location_link')?.value;
  const hasPinCode = Boolean(pinCode?.pin)
  return (
    <div role="region" aria-labelledby={nameId} className="not-last:sm:mb-12 not-last:mb-8">
      <div className="sm:mb-[32px] mb-4 flex flex-wrap flex-col items-start justify-between sm:gap-[12px] gap-[6px] sm:px-0 px-4">
        <div id={nameId} className="text-foreground sm:text-[18px] text-[16px] sm:leading-[24px] leading-[22px]">{facilityName}</div>
        {isGroupLocked ? (
            <span className="inline-flex items-center gap-2 sm:text-lg text-[16px] sm:leading-6 leading-[22px] text-[#df0f0f]">
              <LockIcon size={18} className="size-[18px]" /> {t('contracts.group.locked')}
            </span>
          ) : hasPinCode || facilityLocationLink ? (
            <div className="flex items-center justify-between gap-2 w-full">
              {hasPinCode ? (
                <Button
                  variant="link"
                  className="cursor-pointer inline-flex items-center gap-2 sm:text-lg text-[16px] sm:leading-6 leading-[22px] text-muted-foreground transition-colors hover:text-brand px-0"
                  onClick={() => setIsPinCodeVisible(prev => !prev)}
                >
                  {isPinCodeVisible ? (
                    <>
                      <EyeOffIcon size={18} className="size-[18px]" />
                      <span>{pinCode?.pin}</span>
                    </>
                  ) : (
                    <>
                      <EyeIcon size={18} className="size-[18px]" />
                      <span>Показать пин-код</span>
                    </>
                  )}
                </Button>
              ) : null}
              {facilityLocationLink ? (
                <a
                  href={facilityLocationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={cn(
                    "cursor-pointer inline-flex items-center gap-2 text-lg leading-6 text-muted-foreground transition-colors hover:text-brand px-0",
                    !hasPinCode && "ml-auto",
                  )}
                >
                  <MapPinIcon size={18} className="size-[18px]" />
                  <span>На карте</span>
                </a>
              ) : null}
            </div>
          ) : null
        }
        
      </div>

      <div className="flex flex-col sm:gap-6 gap-2">
        {contracts.map(contract => (
          <ContractsCard
            key={contract.id}
            contract={contract}
            props={{ isGroupLocked: isGroupLocked }}
          />
        ))}
      </div>
    </div>
  )
}